import { Percent } from "@silo/types";
import { cn } from "../../utils/class-names";
import { asWholePercent, normalizeToPoints } from "@silo/utils";
import { StaticBar } from "./static-bar";

interface StaticHealthFactorProps {
  className?: string;
  healthFactor: Percent;
}

export function StaticHealthFactor({
  className,
  healthFactor,
}: StaticHealthFactorProps): JSX.Element {
  const points = normalizeToPoints(healthFactor);

  return (
    <div className={cn("flex flex-col gap-2", className)}>
      <div className="flex justify-between text-base">
        <div className="text-shale-200">Health factor</div>

        <div
          className="font-mono font-medium text-white"
          data-cy="health-factor-percentage"
        >
          {asWholePercent(healthFactor)}
        </div>
      </div>

      <div>
        <StaticBar points={points} />
      </div>
    </div>
  );
}
